<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
  <v-row
    v-if="currDevice.data != {}"
    no-gutters
    class="fill-height">
    <v-col cols=3 class="fill-height">
      <v-sheet
          height="100vh"
          width="100vw"
          class="whitespace fill-height fill-width"
          @click="close()"
        >
      </v-sheet>
    </v-col>
    <v-col cols=9 class="sideview" height="200px">
        <v-sheet
          elevation="3"
          height="100vh"
          width="100vw"
          class="sideview fill-height fill-width"
        >
            <v-row
              class="px-6 pt-2 fill-height">
              <v-col cols=9 class="pt-2 pb-12 fill-height">
                <div class="d-flex">
                  <div class="d-inline pa-2 ml-auto">
                    <TheMiniLoader :loading="isLoading" />
                  </div>
                  <v-btn
                    icon
                    color="textColor"
                    class="ml-4"
                    @click="refreshData"
                  >
                    <v-icon>mdi-autorenew</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    color="textColor"
                    @click="close"
                  >
                    <v-icon>mdi-window-close</v-icon>
                  </v-btn>
                </div>
                  <span class="title grayBold--text">
                      {{ $t(currDevice.info.device_type) }}
                  </span>
                  <v-list-item two-line>
                    <v-list-item-avatar
                      tile
                      size=60
                     >
                        <!-- <v-icon large color="grayBold">
                          mdi-home-city-outline
                        </v-icon> -->
                        <v-img :src="require('@/assets/img/smart-home.png')"/>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="overline pl-2 mb-1 titleGrey--text">{{ $t("device_id") }}</v-list-item-title>
                      <v-list-item-subtitle class="subtitle-1 pl-2 titleGrey--text">{{ currDevice.data.deviceId }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-tooltip top color="gray">
                        <template v-slot:activator="{ on, attrs }">
                        <v-chip
                          v-if="currDevice.data?.onlineState || false"
                          v-bind="attrs"
                          v-on="on"
                          class="ma-2 chip"
                          color="success"
                          input-value="1"
                          outlined
                          small>
                          <v-icon
                            left
                            small>mdi-checkbox-marked-circle</v-icon>{{ $t("online") }}
                        </v-chip>
                        <v-chip
                          v-else
                          v-bind="attrs"
                          v-on="on"
                          class="ma-2 chip"
                          color="error"
                          input-value="1"
                          outlined
                          small>
                          <v-icon
                            left
                            small>mdi-alert-circle-outline</v-icon>{{ $t("offline") }}
                        </v-chip>
                        </template>
                        {{ $t("from") + ' ' + formatDate(currDevice.data?.last_update) }} 
                      </v-tooltip>
                      <v-tooltip v-if="currDevice.data.properties.device?.rssi" top color="gray">
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip
                            v-if="currDevice.data.properties.device.rssi"
                            v-bind="attrs"
                            v-on="on"
                            class="ma-2 chip"
                            :color="wifiSignalToColor(currDevice.data.properties.device?.rssi)"
                            input-value="1"
                            outlined
                            small>
                            <v-icon
                              class="mr-1"
                              left
                              small>mdi-wifi
                            </v-icon>
                            {{$t("signal") }}
                            {{ $t((wifiSignalToMessage(currDevice.data.properties.device?.rssi))) }}
                          </v-chip>
                        </template>
                        {{ 'RSSI: ' + currDevice.data.properties.device?.rssi.toFixed(0) + ' dBm' }} 
                      </v-tooltip>
                    </v-list-item-action>
                  </v-list-item>
                <v-tabs 
                  v-model="currTab"
                  color="primary"
                  show-arrows
                  background-color="transparent"
                  class="tabs" light>
                  <v-tab>{{ $t("general") }}</v-tab>
                  <v-tab>{{ $t("remote_control") }}</v-tab>
                  <v-tab>{{ $t("graphs") }}</v-tab>
                  <v-tab>{{ $t("boiler_faults") }}</v-tab>
                  <v-tab>{{ $t("information") }}</v-tab>
                </v-tabs>
                <v-tabs-items v-model="currTab">
                  <v-tab-item light key=0>
                    <DevicesSideviewGeneralTab :device="currDevice"/>
                  </v-tab-item>
                  <v-tab-item light key=1>
                    <DevicesSideviewControlTab :device="currDevice"/>
                  </v-tab-item>
                  <v-tab-item light key=2>
                    <DevicesSideviewChartsTab :device="currDevice"/>
                  </v-tab-item>
                  <v-tab-item light key=3>
                    <DevicesSideviewFaultsTab :device="currDevice"/>
                  </v-tab-item>
                  <v-tab-item light key=4>
                    <DevicesSideviewInfoTab :device="currDevice"/>
                  </v-tab-item>
                </v-tabs-items>
                  <v-divider class="mx-4 mt-2"/>
                  <v-list-item class="pt-12">
                    <v-list-item-content>
                      <v-list-item-title class="overline textColor2--text">
                        {{ $t("installation_date_uppercase") }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="pt-1 textColor2--text"> {{ formatDate(currDevice.info.installation_date) }} </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
              </v-col>
            </v-row>
        <LoadingIndicator :loading="loading" />
        </v-sheet>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { commonModule, installationsModule, companyModule, devicesModule, distributorModule } from '@/store/modules/store-accessor'
import LoadingIndicator from '@/components/TheLoadingIndicator.vue'
import DevicesSideviewGeneralTab from '@/components/sideviews/devices/DevicesSideviewGeneralTab.vue'
import DevicesSideviewInfoTab from '@/components/sideviews/devices/DevicesSideviewInfoTab.vue'
import DevicesSideviewChartsTab from '@/components/sideviews/devices/DevicesSideviewChartsTab.vue'
import DevicesSideviewControlTab from '@/components/sideviews/devices/DevicesSideviewControlTab.vue'
import DevicesSideviewFaultsTab from '@/components/sideviews/devices/DevicesSideviewFaultsTab.vue'
import { TimeUtil } from '@/helpers/TimeUtil'
import FileSaver from 'file-saver';
import moment from 'moment';
import TheMiniLoader from '@/components/TheMiniLoader.vue'
import { getWiFiSignalLevelFromRSSI } from '@/helpers/data'

@Component({
  components: {
    LoadingIndicator,
    DevicesSideviewGeneralTab,
    DevicesSideviewInfoTab,
    DevicesSideviewControlTab,
    DevicesSideviewChartsTab,
    DevicesSideviewFaultsTab,
    TheMiniLoader
  }
})
export default class DistributorDeviceSideview extends Vue {
  @Prop()
  loading!: boolean;

  @Prop()
  payload!: any;
  
  currTab = this.payload?.tab || 0;

  isEditing!: boolean;

  timer: ReturnType<typeof setInterval> | null = null;

  get deviceId (): string | undefined {
    return this.payload?.deviceId ?? this.currDevice?.info?.device_id;
  }

  stopPolling () {
    if (this.timer != null) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  startPolling () {
    this.stopPolling();
    if (this.currTab === 0 || this.currTab === 1) {
      this.timer = setInterval(() => {
        this.refreshData();
      }, 10000);
    }
  }

  @Watch('currTab')
  checkTimer () {
    this.startPolling();
  }

  async hideSideview () {
    commonModule.hideSideview();
  }

  get currDevice () {
    return devicesModule.currentDevice
  }

  formatDate (date: Date): string {
    return TimeUtil.formatDateTime(date)
  }

  updated() {
    this.isEditing = false;
  }

  wifiSignalToMessage(rssi: number) {
    return getWiFiSignalLevelFromRSSI(rssi)["message"]
  }

  wifiSignalToColor(rssi: number) {
    return getWiFiSignalLevelFromRSSI(rssi)["color"]
  }

  mounted () {
    this.currTab = this.payload?.tab || 0;
    this.startPolling();
  }

  beforeDestroy () {
    this.stopPolling();
  }


  get isLoading() {
    return false;
  }

  refreshData () {
    const deviceId = this.deviceId;
    if (!deviceId) {
      return;
    }
    devicesModule.getDeviceInfo(deviceId);
  }

  close () {
    this.stopPolling();
    devicesModule.unsetCurrentDevice();
    this.hideSideview();
  }

};
</script>

<style scoped lang="scss">

.sideview {
  max-height: 100vh !important;
  background-color:whitesmoke;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.tabs {
  background: $whitesmoke;
  color:transparent;
}

.title {
  margin-top: 5px;
  font-size: 35;
  font-weight: 500;
}

h2 {
  color: $dark-blue-grey;
}

span {
  margin-left: 10px;
  font-size: 1.5rem !important;
  font-weight: 400;
  color: $pale-purple;
}

.close-btn {
  color: $card-title-color;
}

.loading {
  margin: 5px;
  right: 1px;
}

.chip {
  font-size: 12px !important;
}

.whitespace {
  width: 100%;
  height: 100%;
  background-color:transparent;
}
</style>
